<!-- Loading global enquanto isLoading true -->
<div *ngIf="isLoading" class="flex justify-center items-center flex-col gap-5 h-[100vh]">
  <div
    class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg">
  </div>
  <span class="text-[--lightRed]">Carregando...</span>
</div>

<!-- Se plano free, mostrar aviso -->
<div *ngIf="!isLoading && isFreePlan"
  class="bg-red-100 border border-red-400 text-red-700 px-4 py-5 rounded relative text-center max-w-lg mx-auto mt-10">
  <i class='bx bxs-lock text-4xl text-[#D62828] mb-2'></i>
  <p class="font-semibold text-lg">Este conteúdo é exclusivo para assinantes.</p>
  <p class="text-sm mb-4">Assine agora para ter acesso completo às questões e simulações.</p>
  <button class="bg-[#D62828] hover:bg-[#b31f1f] text-white font-bold py-2 px-6 rounded-full text-sm mx-auto"
    [routerLink]="['/my-space/my-plan']">
    Assinar agora
  </button>
</div>

<!-- Conteúdo do exame para assinantes -->
<div *ngIf="!isLoading && !isFreePlan">
  <div class="fixed top-0 left-0 bg-[#E2E3FD] text-black p-3 rounded-lg shadow-md flex items-center gap-3">
    <i class="bx bx-time text-2xl"></i>
    <span id="counter" [class.hidden]="isHidden">{{ formattedTime }}</span>
    <button (click)="toggleCounterVisibility()"
      class="bg-blue-500 text-white py-1 px-3 rounded flex items-center gap-1">
      <i class="bx" [class.bx-show]="isHidden" [class.bx-hide]="!isHidden"></i>
    </button>
    <button (click)="togglePause()" class="bg-green-500 text-white py-1 px-3 rounded flex items-center gap-1">
      <i class="bx" [class.bx-play]="isPaused" [class.bx-pause]="!isPaused"></i>
    </button>
  </div>

  <div class="text-center  bg-[--lightRed] text-white w-fit mx-auto rounded-lg my-[20px]">
    <h5 class="py-2 px-3">
      <i class='bx bx-book-open'></i>
      Exame #FACSQ{{eid}}
    </h5>
  </div>
  <main id="questions_container" class="flex flex-col py-5 bg-white rounded-xl">
    <app-question *ngFor="let question of questions" [question]="question"></app-question>
  </main>

  <div class="flex justify-center my-[50px] ">
    <button class="flex text-left bg-[var(--lightRed)] text-white p-2  mt-5 w-fit rounded-xl my-auto"
      (click)="finishExam()">
      Finalizar exame <i class='bx bx-send'></i>
    </button>
  </div>
</div>
